<div class="policy-page">
  <div class="policy-container">
    <h1>RETURNS POLICY</h1>

    <p class="brand-name"><strong>Pixie Pets</strong></p>
    <p class="last-updated"><em>Last updated: 22.12.2025</em></p>

    <hr>

    <h2>Our approach to returns</h2>
    <p>At Pixie Pets, every product is created especially for you and your pet.<br>
    Because of that, most items are <strong>personalized and made to order</strong>.</p>
    <p>At the same time, we care deeply about your satisfaction and want you to be happy with what you receive. If something goes wrong, we're here to help.</p>

    <hr>

    <h2>Personalized products</h2>
    <p>Because products are custom-made using your pet's photo and selected style:</p>
    <ul>
      <li>We <strong>do not accept returns or exchanges</strong> for reasons such as:
        <ul>
          <li>change of mind,</li>
          <li>ordering the wrong size or product,</li>
          <li>personal preference after delivery.</li>
        </ul>
      </li>
    </ul>
    <p>This is standard for personalized products and allows us to keep quality high and production efficient.</p>

    <hr>

    <h2>When we <em>do</em> offer help</h2>
    <p>We will happily review your case if:</p>
    <ul>
      <li>your product arrives <strong>damaged</strong>, or</li>
      <li>there is a <strong>clear manufacturing or printing error</strong>.</li>
    </ul>
    <p>If this happens, please contact us within <strong>30 days of delivery</strong>.</p>
    <p>To help us resolve the issue quickly, we may ask for:</p>
    <ul>
      <li>a short description of the problem,</li>
      <li>photos showing the issue.</li>
    </ul>
    <p>Approved cases may qualify for a <strong>replacement or refund</strong>, depending on the situation.</p>

    <hr>

    <h2>Our promise</h2>
    <p>Even when a case does not qualify for a return under this policy, we still encourage you to reach out.</p>
    <p>We genuinely care about your experience and will always try to find a fair and thoughtful solution — for you and your pet.</p>

    <hr>

    <h2>How to contact us</h2>
    <p>If you have any concerns about your order, please contact our support team:</p>
    <p><strong><a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a></strong></p>
    <p>We'll do our best to help and guide you through the next steps.</p>

    <hr>

    <h2>Policy updates</h2>
    <p>This Returns Policy may be updated from time to time.<br>
    The current version will always be available on our website.</p>
  </div>
</div>
